import React from 'react';

const Aufnahmeregeln = () => {
  return (
    <div className="drawer-page">
      <h1 className="aufnahmeregeln__title">
        Aufnahmeregeln für Events auf «Grosskinder Aktiv»
      </h1>

      {/* Grundprinzip */}
      <div className="card aufnahmeregeln__card">
        <h3 className="aufnahmeregeln__card-heading">Grundprinzip</h3>
        <p className="aufnahmeregeln__text">
          Ein Event oder Angebot wird aufgenommen, wenn es primär dem Erlebnis des Kindes dient –
          nicht dem wirtschaftlichen Interesse des Anbieters.
        </p>
      </div>

      {/* Positivkriterien */}
      <div className="card aufnahmeregeln__card">
        <h3 className="aufnahmeregeln__card-heading">
          Positivkriterien <span className="aufnahmeregeln__heading-sub">(mind. eines muss erfüllt sein)</span>
        </h3>
        <ul className="aufnahmeregeln__list">
          <li>Das Angebot ist unabhängig von einem Konsumzweck nutzbar (kein Kauf nötig)</li>
          <li>
            Es hat einen klar definierten inhaltlichen Charakter: Lernen, Bewegen, Entdecken,
            Kreativ sein, Natur erleben
          </li>
          <li>
            Es wird von einer gemeinnützigen oder öffentlichen Institution betrieben (Verein,
            Gemeinde, Schule, Museum, Bibliothek)
          </li>
          <li>Es ist ein einmaliges Community-Event ohne primären Verkaufszweck</li>
        </ul>
      </div>

      {/* Ausschlusskriterien */}
      <div className="card aufnahmeregeln__card">
        <h3 className="aufnahmeregeln__card-heading">
          Ausschlusskriterien <span className="aufnahmeregeln__heading-sub">(eines genügt für Ablehnung)</span>
        </h3>
        <ul className="aufnahmeregeln__list">
          <li>
            Das Angebot ist Teil eines Gastronomie- oder Retail-Betriebs, dessen Hauptzweck nicht
            Kinderaktivitäten ist (Restaurant mit Spielecke, Mall mit Kinderbereich)
          </li>
          <li>
            Die Aktivität dient primär der Kundenbindung oder Besuchergewinnung für ein
            kommerzielles Angebot
          </li>
          <li>Es handelt sich um bezahlte Platzierung oder Eigenwerbung eines Unternehmens</li>
          <li>Der Veranstalter hat keine pädagogische, kulturelle oder soziale Mission</li>
          <li>
            Das Angebot ist nur im Kombi-Paket nutzbar (z.B. Hüpfburg gratis, aber Eintritt ins
            Restaurant obligatorisch)
          </li>
        </ul>
      </div>

      {/* Grenzfälle */}
      <div className="card aufnahmeregeln__card">
        <h3 className="aufnahmeregeln__card-heading">Grenzfälle – Entscheidungshilfe</h3>
        <div className="aufnahmeregeln__table-wrap">
          <table className="aufnahmeregeln__table">
            <thead>
              <tr>
                <th>Beispiel</th>
                <th>Entscheid</th>
                <th>Begründung</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Technorama (Eintritt kostenpflichtig)</td>
                <td className="aufnahmeregeln__decision--yes">✅ Aufnehmen</td>
                <td>Kernmission ist Bildung/Erleben</td>
              </tr>
              <tr>
                <td>Restaurant mit Spielplatz im Garten</td>
                <td className="aufnahmeregeln__decision--no">❌ Ablehnen</td>
                <td>Spielplatz dient dem Restaurantbesuch</td>
              </tr>
              <tr>
                <td>Migros-Kinderworkshop (gratis, extern)</td>
                <td className="aufnahmeregeln__decision--maybe">🔍 Prüfen</td>
                <td>Wenn inhaltlich eigenständig und ohne Kaufdruck</td>
              </tr>
              <tr>
                <td>Trampolinpark (kommerziell, aber Kernprodukt)</td>
                <td className="aufnahmeregeln__decision--yes">✅ Aufnehmen</td>
                <td>Aktivität selbst ist das Angebot</td>
              </tr>
              <tr>
                <td>Ikea Kinderbereich</td>
                <td className="aufnahmeregeln__decision--no">❌ Ablehnen</td>
                <td>Reine Kundenbindungsmassnahme</td>
              </tr>
              <tr>
                <td>Quartier-Kinderfest eines Vereins</td>
                <td className="aufnahmeregeln__decision--yes">✅ Aufnehmen</td>
                <td>Community-Zweck klar</td>
              </tr>
              <tr>
                <td>Bäckerei mit Backkurs für Kinder</td>
                <td className="aufnahmeregeln__decision--maybe">🔍 Prüfen</td>
                <td>Nur wenn Kurs unabhängig vom Verkauf, angemessen bepreist</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      {/* Leitfrage */}
      <div className="card aufnahmeregeln__card">
        <h3 className="aufnahmeregeln__card-heading">Leitfrage für Moderatoren</h3>
        <blockquote className="aufnahmeregeln__blockquote">
          «Würde jemand dieses Angebot besuchen, auch wenn er dort nichts kaufen müsste?»
        </blockquote>
        <p className="aufnahmeregeln__note">
          <strong>Ja</strong> → tendenziell aufnehmen. &nbsp;
          <strong>Nein</strong> → tendenziell ablehnen.
        </p>
      </div>
    </div>
  );
};

export default Aufnahmeregeln;
